import styles from '../../assets/styles/BusinessInsights/BusinessInsights.module.scss';
import { amountFormatter } from '../../utils/utils';
import { MimaText } from '../../components';
import { FaCalendar } from 'react-icons/fa';
import React from 'react';
import { MimaAmountBarChart, MimaPercentageBarChart } from '../../components/MimaBarChart';

const BusinessChartCard = ({ expenseAnalysis, expensePercentage, currencyCode }) => {
	return (
		<div className={styles.bi}>
			<MimaText variant="subtitle" mt={5} align="center">
				{`${currencyCode} Expense Analysis`}
			</MimaText>

			<div className={styles.bi__sideCards}>
				<div className={styles.bi__mainCards_b}>
					<div className={styles.card_top}>
						<div className={styles.card_top_icon}>
							<FaCalendar />
						</div>
						<MimaText variant="bodyBold" color="var(--color-primary)">
							Percentage Analysis
						</MimaText>
					</div>
					<div className={styles.card_pie}>
						<MimaPercentageBarChart data={expenseAnalysis} />
					</div>
				</div>

				<div className={styles.bi__mainCards_b}>
					<div className={styles.card_top}>
						<div className={styles.card_top_icon}>
							<FaCalendar />
						</div>
						<MimaText variant="bodyBold" color="var(--color-primary)">
							Amount Analysis
						</MimaText>
					</div>
					<div>
						<MimaAmountBarChart
							data={expenseAnalysis}
							currency={currencyCode} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default BusinessChartCard;
